export const metaLabels: Record<string, any> = {
  "en-gb": [
    {
      "metaDescription": "Enjoy surplus food from ${storeName} - ${branch} in ${city} at just ${price}. Reduce waste with Too Good To Go.",
      "metaTitle": "${storeName} ${branch} | Too Good To Go in ${city} - Save good food near you"
    },
    {
      "metaDescription": "Enjoy surplus food from ${storeName} - ${branch} in ${city} at just ${price}. Reduce waste with Too Good To Go.",
      "metaTitle": "${storeName} ${branch} | Too Good To Go in ${city} - Save good food near you"
    }
  ],
  "en-au": {
    "metaDescription": "Enjoy surplus food from ${storeName} ${branch} in ${city} at just ${price}. Reduce waste with Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go in ${city} – Save good food near you"
  },
  "de-at": {
    "metaDescription": "Rette überschüssige Lebensmittel von ${storeName} ${branch} in ${city} für nur ${price}. Reduziere Food Waste mit Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go in ${city} – Rette gute Lebensmittel in deiner Nähe"
  },
  "nl-be": {
    "metaDescription": "Geniet van overgebleven eten van ${storeName} ${branch} in ${city} voor slechts ${price}. Verminder verspilling met Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go in ${city} – Red goed eten in jouw buurt"
  },
  "fr-be": {
    "metaDescription": "Profitez des invendus de ${storeName} ${branch} à ${city} pour seulement ${price}. Réduisez le gaspillage avec Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go à ${city} – Sauvez de la bonne nourriture près de chez vous"
  },
  "en-ca": {
    "metaDescription": "Enjoy surplus food from ${storeName} ${branch} in ${city} at just ${price}. Reduce waste with Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go in ${city} – Save good food near you"
  },
  "fr-ca": {
    "metaDescription": "Profitez de la nourriture invendue de ${storeName} ${branch} à ${city} pour seulement ${price}. Réduisez le gaspillage avec Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go à ${city} – Sauvez de la bonne nourriture près de chez vous"
  },
  "da": [
    {
      "metaDescription": "Red overskudsmad fra ${storeName} ${branch} i ${city} til kun ${price}. Mindsk madspild med Too Good To Go.",
      "metaTitle": "${storeName} ${branch} | Too Good To Go i ${city} – Red god mad nær dig"
    },
    {
      "metaDescription": "Red overskudsmad fra ${storeName} ${branch} i ${city} til kun ${price}. Mindsk madspild med Too Good To Go.",
      "metaTitle": "${storeName} ${branch} | Too Good To Go i ${city} – Red god mad nær dig"
    },
    {
      "metaDescription": "Enjoy surplus food from ${storeName} - ${branch} in ${city} at just ${itemPrice}. Reduce waste with Too Good To Go.",
      "metaTitle": "${storeName} - ${branch} | Too Good To Go in ${city} - Save good food near you"
    }
  ],
  "fr": {
    "metaDescription": "Profitez des produits de ${storeName} ${branch} à ${city} pour seulement ${price}. Réduisez le gaspillage avec Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go à ${city} – Sauvez de bons repas près de chez vous"
  },
  "de": {
    "metaDescription": "Rette überschüssige Lebensmittel von ${storeName} ${branch} in ${city} für nur ${price}. Reduziere Food Waste mit Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go in ${city} – Rette gute Lebensmittel in deiner Nähe"
  },
  "en-ie": {
    "metaDescription": "Enjoy surplus food from [storeName] ${branch} in ${city} at just ${price}. Reduce waste with Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go in ${city} – Save good food near you"
  },
  "it": {
    "metaDescription": "Goditi il cibo invenduto di ${storeName} ${branch} a ${city} a soli ${price}. Riduci gli sprechi con Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go a ${city} – Salva buon cibo dallo spreco vicino a te"
  },
  "no": {
    "metaDescription": "Nyt overskuddsmat fra ${storeName} ${branch} i ${city} til bare ${price}. Reduser matsvinn med Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go i ${city} – Redd god mat nær deg"
  },
  "pl": {
    "metaDescription": "Ciesz się nadwyżkami żywności z ${storeName} ${branch} w ${city} za jedynie ${price}. Zmniejsz marnotrawstwo z Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go w ${city} – Ratuj dobrą żywność w pobliżu"
  },
  "pt": {
    "metaDescription": "Aproveita comida excedente de ${storeName} ${branch} em ${city} por apenas ${price}. Reduz o desperdício com a app Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go em ${city} – Salva boa comida perto de ti"
  },
  "es": {
    "metaDescription": "Disfruta de comida de ${storeName} ${branch} en ${city} por solo ${price}. Reduce el desperdicio de alimentos con Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go en ${city} – Salva buena comida cerca de ti"
  },
  "sv": {
    "metaDescription": "Njut av överskottsmat från ${storeName} ${branch} i ${city} för endast ${price}. Minska svinnet med Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go i ${city} – Rädda god mat nära dig"
  },
  "de-ch": {
    "metaDescription": "Rette überschüssige Lebensmittel von ${storeName} ${branch} in ${city} für nur ${price}. Reduziere Food Waste mit Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go in ${city} – Rette gute Lebensmittel in deiner Nähe"
  },
  "fr-ch": {
    "metaDescription": "Profitez des invendus de ${storeName} ${branch} à ${city} pour seulement ${price}. Réduisez le gaspillage avec Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go à ${city} – Sauvez de la bonne nourriture près de chez vous"
  },
  "it-ch": {
    "metaDescription": "Goditi il cibo invenduto di ${storeName} ${branch} a ${city} a solo ${price}. Riduci gli sprechi con Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go a ${city} – Salva buon cibo vicino a te"
  },
  "nl": {
    "metaDescription": "Geniet van overgebleven eten van ${storeName} ${branch} in ${city} voor slechts ${price}. Verminder verspilling met Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go in ${city} – Red goed eten in jouw buurt"
  },
  "en-us": {
    "metaDescription": "Enjoy surplus food from ${storeName} ${branch} in ${city} at just ${price}. Reduce waste with Too Good To Go.",
    "metaTitle": "${storeName} ${branch} | Too Good To Go in ${city} – Save good food near you"
  },
  "en-nz": [
    {
      "metaDescription": "Enjoy surplus food from ${storeName} ${branch} in ${city} at just ${price}. Reduce waste with Too Good To Go.",
      "metaTitle": "${storeName} ${branch} | Too Good To Go in ${city} – Save good food near you"
    },
    {
      "metaDescription": "Enjoy surplus food from ${storeName} ${branch} in ${city} at just ${price}. Reduce waste with Too Good To Go.",
      "metaTitle": "${storeName} ${branch} | Too Good To Go in ${city} – Save good food near you"
    }
  ],
  "ja": {
    "metaDescription": "${city}の${storeName}（${branch}）の余剰食品を、わずか${price}でお得に楽しもう。Too Good To Goで食品ロスを減らしましょう。",
    "metaTitle": "${storeName} - ${branch} | ${city}のToo Good To Go - 近くのまだ食べられる食品をお得に救おう"
  }
}